import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { createElement } from "@wordpress/element";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * External dependencies
 */
import { map } from 'lodash';
import scrollIntoView from 'dom-scroll-into-view';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { withSafeTimeout } from '@wordpress/compose';

var SuggestionsList = /*#__PURE__*/function (_Component) {
  _inherits(SuggestionsList, _Component);

  var _super = _createSuper(SuggestionsList);

  function SuggestionsList() {
    var _this;

    _classCallCheck(this, SuggestionsList);

    _this = _super.apply(this, arguments);
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.bindList = _this.bindList.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SuggestionsList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      // only have to worry about scrolling selected suggestion into view
      // when already expanded
      if (this.props.selectedIndex > -1 && this.props.scrollIntoView) {
        this.scrollingIntoView = true;
        scrollIntoView(this.list.children[this.props.selectedIndex], this.list, {
          onlyScrollIfNeeded: true
        });
        this.props.setTimeout(function () {
          _this2.scrollingIntoView = false;
        }, 100);
      }
    }
  }, {
    key: "bindList",
    value: function bindList(ref) {
      this.list = ref;
    }
  }, {
    key: "handleHover",
    value: function handleHover(suggestion) {
      var _this3 = this;

      return function () {
        if (!_this3.scrollingIntoView) {
          _this3.props.onHover(suggestion);
        }
      };
    }
  }, {
    key: "handleClick",
    value: function handleClick(suggestion) {
      var _this4 = this;

      return function () {
        _this4.props.onSelect(suggestion);
      };
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      // By preventing default here, we will not lose focus of <input> when clicking a suggestion
      e.preventDefault();
    }
  }, {
    key: "computeSuggestionMatch",
    value: function computeSuggestionMatch(suggestion) {
      var match = this.props.displayTransform(this.props.match || '').toLocaleLowerCase();

      if (match.length === 0) {
        return null;
      }

      suggestion = this.props.displayTransform(suggestion);
      var indexOfMatch = suggestion.toLocaleLowerCase().indexOf(match);
      return {
        suggestionBeforeMatch: suggestion.substring(0, indexOfMatch),
        suggestionMatch: suggestion.substring(indexOfMatch, indexOfMatch + match.length),
        suggestionAfterMatch: suggestion.substring(indexOfMatch + match.length)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      // We set `tabIndex` here because otherwise Firefox sets focus on this
      // div when tabbing off of the input in `TokenField` -- not really sure
      // why, since usually a div isn't focusable by default
      // TODO does this still apply now that it's a <ul> and not a <div>?
      return createElement("ul", {
        ref: this.bindList,
        className: "components-form-token-field__suggestions-list",
        id: "components-form-token-suggestions-".concat(this.props.instanceId),
        role: "listbox"
      }, map(this.props.suggestions, function (suggestion, index) {
        var match = _this5.computeSuggestionMatch(suggestion);

        var classeName = classnames('components-form-token-field__suggestion', {
          'is-selected': index === _this5.props.selectedIndex
        });
        /* eslint-disable jsx-a11y/click-events-have-key-events */

        return createElement("li", {
          id: "components-form-token-suggestions-".concat(_this5.props.instanceId, "-").concat(index),
          role: "option",
          className: classeName,
          key: _this5.props.displayTransform(suggestion),
          onMouseDown: _this5.handleMouseDown,
          onClick: _this5.handleClick(suggestion),
          onMouseEnter: _this5.handleHover(suggestion),
          "aria-selected": index === _this5.props.selectedIndex
        }, match ? createElement("span", {
          "aria-label": _this5.props.displayTransform(suggestion)
        }, match.suggestionBeforeMatch, createElement("strong", {
          className: "components-form-token-field__suggestion-match"
        }, match.suggestionMatch), match.suggestionAfterMatch) : _this5.props.displayTransform(suggestion));
        /* eslint-enable jsx-a11y/click-events-have-key-events */
      }));
    }
  }]);

  return SuggestionsList;
}(Component);

SuggestionsList.defaultProps = {
  match: '',
  onHover: function onHover() {},
  onSelect: function onSelect() {},
  suggestions: Object.freeze([])
};
export default withSafeTimeout(SuggestionsList);
//# sourceMappingURL=suggestions-list.js.map